import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { ExistingBooking } from '@/widgets/Wizard/models/wizard';

export const useCheckInStore = defineStore('booking-wizard/check-in', () => {
    // State
    const reservationNumber = ref<string | null>(null);
    const booking = ref<ExistingBooking | null>(null);

    // Getters

    // Actions
    const reset = () => {
        reservationNumber.value = null;
        booking.value = null;
    };

    return {
        // State
        reservationNumber,
        booking,

        // Getters

        // Actions
        reset,
    };
});
